import React from 'react';
import HeroSection from '../components/HeroSection';
import BookShowcase from '../components/BookShowcase';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="page-wrapper">
      <div className="page-grain" />
      <main className="main-content">
        <HeroSection />
        <BookShowcase />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
